import { useState } from "react";
import { BasicPage } from "../../theme/Component/BasicPage"
import { ImportXLSX } from "../../theme/Component/ImportXLSX";
import { BasicButton } from "../../theme/Component/BasicButton";
import { _single, _ThirdBankingAccount } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";

export const ImportBankingAccount = () => {

    const { instance, lista, setLista } = useDataBean(_ThirdBankingAccount);

    const [file, setFile] = useState<any>();

    const cargarCuentas = () => {
        console.log("Cargar cuentas)");
        instance.importThirdBankingAccount(_single.getAccountID(), JSON.stringify(file)).then(
            (resp: any) => {
                console.log(resp);
                setLista(resp);
            }
        )

    }

    return (
        <BasicPage titulo="Importar Cuentas Bancarias">
            <div className="row">
                <div className="col-md-6">
                    <ImportXLSX label="Archivo" lodaData={setFile} />
                    <a href="assets/extra/formato-bancos-tercero.xlsx" target="_blank">Descargar Formato</a>
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton icon="" eventClick={cargarCuentas}>Cargar</BasicButton>
                </div>

            </div>
            <div className="row mt-4">
                <div className="col-md-12">
                    {lista.length > 0 &&
                        <>
                            <p>Cantidad registros : {lista.length}</p>
                            <ul>
                                {lista.map((item: string, index: number) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </>
                    }
                </div>
            </div>
        </BasicPage>
    )
}   